export default __webpack_public_path__ + "static/media/hs1.88e4c180.png";